import { IntegrationDefinition } from '../../../types/integrations/IntegrationDefinition';
import { cloneDeep } from 'lodash';
import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';
import { YardiCommercialProperties } from '../../constants/integrations/Yardi';

const definition: IntegrationDefinition = {
  name: IntegrationProviderEnum.YardiCommercial,
  hasCustomUI: true,
  friendlyName: IntegrationProviderEnum.YardiCommercial,
  description: `Defines the properties required for Yardi Commercial integration.`,
  category: IntegrationCategoryEnum.Displays,
  platforms: [],
  type: IntegrationTypeEnum.Api,
  settings: {},
  properties: cloneDeep(YardiCommercialProperties),
};

/**
 * @deprecated Use `YardiCommercialDefinition` from 'application-types' instead.
 * This definition has been moved to the application-types library for better modularity.
 * Import: `import { YardiCommercialDefinition } from 'application-types';`
 */
export { definition };
